import React, { useState, useReducer, useRef, useEffect } from "react";
import { getDatabase, ref, set, push, child } from "firebase/database";
import { VscChromeClose } from "react-icons/vsc";
import AddQuestionComponent from "./AddQuestionComponent";
import NewQuestionComponent from "./NewQuestionComponent";
import Modal from "react-modal";
import $ from "jquery";
import "./AddQuizComponent.css";

const AddQuizComponent = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [quizDbName, setQuizDbName] = useState("");
  const [name, setName] = useState("");
  const [passingScore, setPassingScore] = useState("");
  const [questions, setQuestions] = useState([]);
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [averageRating, setAverageRating] = useState("");
  const [live, setLive] = useState("");
  const [questionsPerEntry, setQuestionsPerEntry] = useState("");
  const [timesTaken, setTimesTaken] = useState("");
  const [imageURL, setImageURL] = useState("");

  const [questionObjects, setQuestionObjects] = useState([]);

  const [inputFieldsError, setInputFieldsError] = useState("");

  const emptyInputStringsValidation = () => {
    return (
      // quizDbName != "" && // ADD AUTO GENERATED ID
      name != "" &&
      passingScore != "" &&
      // questions.length >= 1 &&
      description != "" &&
      category != "" &&
      // averageRating != "" &&
      live != "" &&
      questionsPerEntry != "" &&
      // timesTaken != "" &&
      imageURL != ""
    );
  };

  const moveToTheEnd = () => {
    $(".quizzes-list-inputs").animate(
      {
        scrollTop: $(".quizzes-list-inputs")[0].scrollHeight,
      },
      "200"
    );
  };

  const writeData = (
    quizDbName,
    name,
    passingScore,
    questions,
    description,
    category,
    averageRating,
    live,
    questionsPerEntry,
    timesTaken,
    imageURL
  ) => {
    const db = getDatabase();
    const newQuizKey = push(child(ref(db), "quizzes")).key;
    const questionArray = [];

    // add questions
    for (let i = 0; i < questionObjects.length; i++) {
      const newQuestionKey = push(child(ref(db), "questions")).key;
      questionArray.push(newQuestionKey);
      let currentQuestion = questionObjects[i];

      set(ref(db, "questions/" + newQuestionKey), {
        text: currentQuestion.text,
        correctOption: parseFloat(currentQuestion.correctOption),
        options: currentQuestion.options,
        interviewerName: currentQuestion.interviewerName,
        interviewerTitle: currentQuestion.interviewerTitle,
        assetURL: currentQuestion.assetURL,
        explanationAssetURL: currentQuestion.explanationAssetURL,
      });
    }

    if (emptyInputStringsValidation()) {
      set(ref(db, "quizzes/" + newQuizKey), {
        name: name,
        category: parseFloat(category),
        description: description,
        questions: questionArray,
        passingScore: parseFloat(passingScore),
        averageRating: 0,
        live: live.toLowerCase() === "true",
        questionsPerEntry: parseFloat(questionsPerEntry),
        timesTaken: 0,
        imageURL: imageURL,
      });
      setInputFieldsError(emptyInputStringsValidation());
      props.setModalIsOpen(false);
      setQuizDbName("");
      setName("");
      setPassingScore("");
      setQuestions([]);
      setDescription("");
      setCategory("");
      setAverageRating("");
      setLive("");
      setQuestionsPerEntry("");
      setTimesTaken("");
      setImageURL("");
      window.location.reload(); // temp fix (think how to reload list on adding new quiz (in QuestionsList it works))
    } else {
      setInputFieldsError(emptyInputStringsValidation());
    }
  };

  return (
    <div className="quizzes-list-modal-body">
      <Modal
        closeTimeoutMS={200}
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
          content: {
            position: "absolute",

            width: "30%",
            height: "80%",

            border: "1px solid #ccc",
            background: "#fff",
            overflow: "auto",
            WebkitOverflowScrolling: "touch",
            borderRadius: "15px",
            outline: "none",
            padding: "35px",
            paddingLeft: "45px",

            border: "0",
            bottom: "auto",
            minHeight: "10rem",
            left: "50%",
            position: "fixed",
            right: "auto",
            top: "50%",
            transform: "translate(-50%,-50%)",
            minWidth: "20rem",
            maxWidth: "60rem",
          },
        }}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
      >
        <AddQuestionComponent
          setModalIsOpen={setModalIsOpen}
          questions={questions}
          setQuestions={setQuestions}
          inQuiz={true}
        />
      </Modal>
      <div className="modal-title">
        <h1>Add quiz</h1>
        <button
          className="close-modal-btn"
          onClick={() => props.setModalIsOpen(false)}
        >
          <VscChromeClose size={"20px"} color="grey" />
        </button>
      </div>
      <div className="quizzes-list-inputs">
        <div className="quizzes-list-modal-input-fields">
          {/* <input
          className="modal-input"
          placeholder="Quiz Database Name"
          onChange={(e) => {
            setQuizDbName(e.target.value);             // ADD AUTO GENERATED ID
          }}
        /> */}
          <div
            style={{ display: "flex", flexDirection: "column", width: "50%" }}
          >
            <input
              className="modal-input"
              placeholder="Name"
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Passing Score"
              onChange={(e) => {
                setPassingScore(e.target.value);
              }}
            />
            <div>
              {/* <input
              className="modal-input"
              placeholder="Questions"
              onChange={(e) => {
                setQuestions(e.target.value.split(", "));
              }}
              value={questions.join(", ")}
            /> */}
              {/* <button onClick={() => setModalIsOpen(true)}>Add question</button> */}
            </div>

            <input
              className="modal-input"
              placeholder="Description"
              onChange={(e) => {
                setDescription(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Category"
              onChange={(e) => {
                setCategory(e.target.value);
              }}
            />
            {/* <input
              className="modal-input"
              placeholder="Average Rating"
              onChange={(e) => {
                setAverageRating(e.target.value);
              }}
            /> */}
          </div>
          <div
            style={{ display: "flex", flexDirection: "column", width: "50%" }}
          >
            <input
              className="modal-input"
              placeholder="Live"
              onChange={(e) => {
                setLive(e.target.value);
              }}
            />
            <input
              className="modal-input"
              placeholder="Questions per Entry"
              onChange={(e) => {
                setQuestionsPerEntry(e.target.value);
              }}
            />
            {/* <input
              className="modal-input"
              placeholder="Times Taken"
              onChange={(e) => {
                setTimesTaken(e.target.value);
              }}
            /> */}
            <input
              className="modal-input"
              placeholder="Image or Video URL"
              onChange={(e) => {
                setImageURL(e.target.value);
              }}
            />
          </div>
        </div>

        {/* <div className="new-quiz-questions"> */}
        {questionObjects.map((object, index) => (
          <NewQuestionComponent
            index={index}
            questionObjects={questionObjects}
            objectsSetState={setQuestionObjects}
          />
        ))}
      </div>

      <div style={{ display: "flex", marginTop: "1%", alignItems: "center" }}>
        <button
          className="submit-button"
          onClick={() =>
            writeData(
              quizDbName,
              name,
              passingScore,
              questions,
              description,
              category,
              averageRating,
              live,
              questionsPerEntry,
              timesTaken,
              imageURL
            )
          }
        >
          Add quiz
        </button>
        <p className="error-message">
          {inputFieldsError === "" ? "" : "*Each field is required"}
        </p>
        <button
          onClick={() => {
            setQuestionObjects([...questionObjects, {options: ['', '', '', '']}]);
            moveToTheEnd();
          }}
          className="btn-add-question"
        >
          ADD QUESTION
        </button>
      </div>
    </div>
  );
};

export default AddQuizComponent;
